import React from "react";
import { ResourceProps } from "@refinedev/core";

type AppMenuResourcesContextType = {
    resources: ResourceProps[];
};

const AppMenuResourcesContext = React.createContext<AppMenuResourcesContextType>({
    resources: [],
});

export const AppMenuResourcesProvider = ({
    resources,
    children,
}: {
    resources: ResourceProps[];
    children: React.ReactNode;
}) => {
    return (
        <AppMenuResourcesContext.Provider value={{ resources }}>
            {children}
        </AppMenuResourcesContext.Provider>
    );
};

export const useAppMenuResources = () => React.useContext(AppMenuResourcesContext);

